angular.module('lead')
    .component('leadList', {
        bindings: {
            statistics: '<',
            filters: '<',
            page: '<'
        },
        templateUrl: 'app/lead/list.html',
        controller: function ($scope, $httpParamSerializer, $interval, $state, $stateParams, LeadService, PropertyDealService, LeadBufferIntegration, NavbarLeftMenu) {
            this.PropertyDealService = PropertyDealService;
            this.LeadService = LeadService;
            this.reset = () => this.filters = {filter: this.filters.filter};
            this.externalSourceSystems = [
                {value: 'ESTICRM/RP', label: 'ESTICRM'},
                {value: 'CALLPAGE', label: 'CALLPAGE'},
                {value: 'BUFFER', label: 'BUFOR'},
                {value: 'MORIZON', label: 'MORIZON'}
            ];
            this.statusesWithoutError = ['WAIT', 'START', 'PROSPECT', 'IN', 'RESERVED', 'CONTRACT', 'NOD', 'OUT'];

            this.wasCreatedOnDifferentDay = item => {
                if (!item || !item.acquisitionDate || !item.audit || !item.audit.createdTime) {
                    return false;
                }
                let acquisitionDate = moment(item.acquisitionDate);
                let createdMoment = moment(item.audit.createdTime);
                return acquisitionDate.isValid() && createdMoment.isValid() && !acquisitionDate.isSame(createdMoment, 'day');
            };

            this.integrationStatistics = [];
            this.integrationStatisticsPromise = null;

            this.$onInit = () => {
                this.filters = this.filters || {};
                if (this.statistics) {
                    NavbarLeftMenu.updateCount('/lead', this.statistics.assignedActionRequiredCount);
                }
                if (this.canLoadIntegrationStatistics()) {
                    this.initAutoRefresh();
                }
            }
            this.canLoadIntegrationStatistics = () => !!(this.statistics && this.statistics.integrations && this.statistics.integrations.length);
            this.initAutoRefresh = () => {
                $interval.cancel(this.integrationStatisticsPromise)
                if (!this.canLoadIntegrationStatistics()) {
                    return;
                }
                LeadBufferIntegration.statistics().$promise.then(result => {
                    this.integrationStatistics = result
                    if (result.find(integration => integration.count === null)) {
                        this.unprocessedCount = null;
                    } else {
                        this.unprocessedCount = result.reduce((sum, integration) => sum + integration.count, 0)
                    }
                })
                this.integrationStatisticsPromise = $interval(this.initAutoRefresh, 60000)
            }
            this.$onDestroy = () => $interval.cancel(this.integrationStatisticsPromise);
            this.findIntegrationStatistics = name => this.integrationStatistics.find(integration => integration.name === name);

            this.onManagerFilterChanged = () => {
                this.filters = this.filters || {};
                this.filters.managerMissing = null;
                if (this.filters.filter !== 'all') {
                    this.filters.filter = 'custom';
                }
                this.filters.page = null;
            }

            this.onManagerMissingChanged = noneSelected => {
                this.filters = this.filters || {};
                this.filters.managerMissing = noneSelected === true;
                if (this.filters.managerMissing) {
                    this.filters.manager = null;
                    this.filters.filter = 'custom';
                }
                this.filters.page = null;
            }

            this.onCustomFilterChanged = () => {
                this.filters = this.filters || {};
                this.filters.page = null;
                if (this.filters.customFilter === 'exclude-duplicate-out') {
                    this.filters.status = angular.copy(this.statusesWithoutError);
                }
            }

            this.getExportUrl = (params) => {
                let paramsAll = angular.copy(this.filters || $stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/lead-batch/export?" + $httpParamSerializer(paramsAll)
            }

            this.searchFieldPopover = `
                <div>Prefiksy:</div>
                <div><b>bant*</b> - wypełnione BANT</div>
                <div><b>nobant*</b> - brak BANT</div>
                <div><b>reminder*</b> - wysłane przypomnienie SMS 2h</div>
                <div><b>escalation*</b> - wysłane przypomnienie SMS 2,5h</div>
                <div><b>referrer*</b> - polecający/pośrednik, * wyszukuje klienta</div>
                <div><b>utm*</b> - tagi UTM</div>
            `

            $scope.$on('client.updated', () => $state.reload());
            $scope.$on('lead.updated', () => $state.reload());
            $scope.$on('lead.deleted', () => $state.reload());
            $scope.$on('lead.activity.updated', () => $state.reload());
            $scope.$on('property-deal.updated', () => $state.reload());
            $scope.$on('file.saved', () => $state.reload());
        }
    })
